/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Status_ActiveInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {League_Status_ActiveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_status_active = /** @type {((inputs?: League_Status_ActiveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Status_ActiveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Active")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ativa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attivo")
	return /** @type {LocalizedString} */ ("Active")
});